import React from 'react';
import {
  InputAdornment as MuiInputAdornment,
  type InputAdornmentProps as MuiInputAdornmentProps,
} from '@mui/material';

export type InputAdornmentProps = MuiInputAdornmentProps;

export default function InputAdornment(props: InputAdornmentProps) {
  return <MuiInputAdornment {...props} />;
}
